import React from 'react';

export type PrimaryButtonProps = {
    modifierClass?: string;
    buttonUrl?: string;
    buttonText?: string;
    plain?: boolean;
    target?: string;
    onClick?: (() => void) | ((event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void);
};

const PrimaryButton: React.FC<PrimaryButtonProps> = ({ modifierClass = '', buttonUrl = '#', buttonText = 'Button Text', plain = false, target = '_self', onClick }) => {
    return (
        <a className={`btn-primary ${modifierClass}`} onClick={onClick} href={buttonUrl} target={target} rel={target === '_blank' ? "noopener noreferrer" : undefined}>
            {plain ? <span>{buttonText}</span> : <span><span data-text={buttonText}>{buttonText}</span></span>}
        </a>
    );
};

export default PrimaryButton;